module.exports = {


    address: "Великий Гусляр, ул.Титова д.19 кв.61",

    services: {
        'guid-1': {
            guid: 'guid-1',
            name: 'Горячее водоснабжение',
            debt: 521.53,
            tarif: 20.7
        },
        'guid-2': {
            guid: 'guid-2',
            name: 'Холодное водоснабжение',
            debt: -332.71,
            tarif: 20.7
        },
        'guid-3': {
            guid: 'guid-3',
            name: 'Водоотведение',
            debt: 632.71,
            tarif: 20.7,
        }
    },

    paySystems: [{
            guid: "dac8ee1c-d00f-42ba-a380-db817e79611d",
            name: "Оплата картой",
            image: "https://lk.sistemagorod.ru/wgimg/wg_card.png",
            imageId: 1,
            desc: "Оплата картой",
            type: 1,
            offerUrl: "https://github.com/",
            code: "cards"
        },
        {
            guid: "dac8ee2c-d00f-42ba-a380-db817e79611d",
            name: "ПСБ Онлайн",
            image: "https://lk.sistemagorod.ru/lk/resources/img/logo_psb.png",
            imageId: 1,
            desc: "Оплата через Промсвязьбанк",
            type: 1,
            offerUrl: "https://github.com/",
            code: "psb"
        },
        {
            guid: "dac8ee3c-d00f-42ba-a380-db817e79611d",
            name: "МИР",
            image: "https://lk.sistemagorod.ru/lk/resources/img/footer/logo_mir.png",
            imageId: 1,
            desc: "Оплата через платежную систему МИР",
            type: 1,
            offerUrl: "https://github.com/",
            code: "mir"
        },
        {
            guid: "dac8ee4c-d00f-42ba-a380-db817e79611d",
            name: "VISA",
            image: "https://lk.sistemagorod.ru/lk/resources/img/logo_visa.gif",
            imageId: 1,
            desc: "Оплата пластиковой картой",
            type: 1,
            offerUrl: "https://github.com/",
            code: "visa"
        },
        {
            guid: "dac8ee5c-d00f-42ba-a380-db817e79611d",
            name: "Mastercard",
            image: "https://lk.sistemagorod.ru/lk/resources/img/logo_mc.gif",
            imageId: 1,
            desc: "Оплата пластиковой картой",
            type: 1,
            offerUrl: "https://github.com/",
            code: "mc"
        }
    ],

    meters: {
        'guid-112314': {
            guid: 'guid-112314',
            service: 'Горячее водоснабжение',
            prev: 193,
            current: 197,
            measure: 'м3',
            location: 'санузел',
            maxConsum: 50,
            capacity: 5,
            fraction: 6,
            canReading: false,
            services: ['guid-1', 'guid-3']
        },
        'guid-1213422': {
            guid: 'guid-1213422',
            service: 'Горячее водоснабжение',
            prev: 76,
            current: 78,
            measure: 'м3',
            location: 'кухня',
            maxConsum: 50,
            capacity: 5,
            fraction: 6,
            canReading: true,
            services: ['guid-1', 'guid-3']
        },
        "guid-212313": {
            guid: "guid-212313",
            service: 'Холодное водоснабжение',
            prev: 93,
            current: '',
            measure: 'м3',
            location: 'санузел',
            maxConsum: 50,
            capacity: 5,
            fraction: 6,
            canReading: true,
            services: ['guid-2', 'guid-3']
        },
        'guid-223421': {
            guid: 'guid-223421',
            service: 'Холодное водоснабжение',
            prev: 21,
            current: '',
            measure: 'м3',
            location: 'кухня',
            maxConsum: 50,
            capacity: 5,
            fraction: 6,
            canReading: true,
            services: ['guid-2', 'guid-3']
        }
    },

    returnResult(data, timeout) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(data);
            }, timeout || 1000);
        });
    },


    getParams([providerGuid, widgetType]) {
        let fields = []

        if (providerGuid == "MOCK-PROVIDER-GUID-2" || providerGuid == "MOCK-PROVIDER-GUID-3") {
            fields.push({
                name: 'mock-field-1',
                value: 'Значение то',
                label: 'Это поле ввода',
                type: 'text'
            })
        }

        if (providerGuid == "MOCK-PROVIDER-GUID-3") {
            fields.push({
                name: 'mock-field-2',
                value: 'Значение это',
                label: 'Другое поле ввода',
                type: 'text'
            })
        }

        let response = {
            "captchaKey": "6LfNpK8UAAAAAIFsX3fXFb61epZ-0FyeP_H5vVNS",
            fields,
            "privacyPolicyUrl": "https://barnaul.rosvodokanal.ru/upload/konfidencialnost-obrabotki-personalnoj-informacii.pdf"
        }

        return this.returnResult(response, 1000)
    },

    searchService([providerGuid, account, fields, captchaAnswer]) {
        return this.returnResult({
            address: this.address,
            withoutCharge: account == '123456',

            services: Object.values(this.services).map(serv => {
                serv.amount = Math.max(serv.debt, 0)
                return serv
            }),
            paySystems: this.paySystems,
            total: {
                total: Object.values(this.services).reduce((sum, serv) => {
                    return sum + Math.max(serv.debt, 0)
                }, 0) * 1.05,
                commission: Object.values(this.services).reduce((sum, serv) => {
                    return sum + Math.max(serv.debt, 0)
                }, 0) * 0.05
            },

            canRegister: true,
        })
    },

    searchMeters([providerGuid, account, fields, captchaAnswer]) {
        return this.returnResult({
            address: this.address,
            meters: Object.values(this.meters)
        })
    },

    calcTotalWithSumm([provider, paySystem, servicesSumm]) {
        var delay = this._getRandomInt(200, 1000)
        let total = Object.values(servicesSumm).reduce((sum, amount) => {
            return sum + Math.max(amount, 0)
        }, 0)
        return this.returnResult({
            total: total * 1.05,
            commission: (total * 1.05 - total)
        }, delay)
    },

     //Максимум не включается, минимум включается
    _getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    },

    savePaymentWithSumm([provider, paySystem, servicesSumm, phoneEmail, needRegister]) {
        return this.returnResult({
            url: 'https://www.sistemagorod.ru/'
        })
    },

    sendReading([provider, readings]) {
        let meters = readings.map(i => {
            let meter = this.meters[i.meter]
            meter.current = i.reading
            return meter
        })
        let services = meters.flatMap(m => m.services).filter((val, i, arr) => arr.indexOf(val) === i).map(servGuid => this.services[servGuid])
        let result = {
            services: services.reduce((res, service) => {
                res[service.guid] = this._calcCharge(service)
                return res
            }, {})
        }

        return this.returnResult(result)
    },

    _calcCharge(service) {
     
        let meters = Object.values(this.meters).filter(m => m.services.includes(service.guid)) //meters.map( meterId => this.data.meters.find( m => m.guid == meterId))

        if (meters.some(m => !m.current)) {
            return {
                charge: 0,
                hasCharge: false,
                amount: Math.max(service.debt, 0)
            }
        }

        let charge = meters.reduce((summ, meter) => {
            return summ + Math.abs(meter.current - meter.prev)
        }, 0) * service.tarif

        return {
            charge,
            hasCharge: true,
            amount: charge + Math.max(service.debt, 0)
        }
    },


}